import PropTypes from 'prop-types';

/**
 * Section component for page sections
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.background - Background color/style (optional)
 * @param {React.ReactNode} props.children - Section content
 */
const Section = ({ className = '', background, children, ...props }) => {
  const backgroundClasses = {
    white: 'bg-white',
    gray: 'bg-neutral-soft-gray',
    gradient: 'bg-gradient-hero',
  };

  const bgClass = background ? backgroundClasses[background] : '';

  return (
    <section
      className={`section-padding ${bgClass} ${className}`}
      {...props}
    >
      {children}
    </section>
  );
};

Section.propTypes = {
  className: PropTypes.string,
  background: PropTypes.oneOf(['white', 'gray', 'gradient']),
  children: PropTypes.node.isRequired,
};

export default Section;
